import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { InitialFeedbackPrefDataType } from '../../models/preference/feedbackformpreference.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';

import useHttps from '../useHttps';
import useGetUserData from '../dashboard/settings/useGetUserData';

const useUpdateInitialFeedbackPrompt = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const { getUserData } = useGetUserData();

  const onUpdateInitialFeedbackPromptError = (
    err: AxiosError<ErrorHttpResponse>
  ) => {
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while updating feedback prompt preference'
    );
  };

  const onUpdateInitialFeedbackPromptSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success(
      'Thank you for letting us know, we will try not to bring this up again'
    );
    sessionStorage.setItem('SIFP', 'false');
    getUserData();
  };

  const updateInitialFeedbackPrompt = async (
    data: InitialFeedbackPrefDataType
  ) => {
    // invert the boolean flag
    const payload = {
      showFeedbackPrompt: !data.showInitialFeedbackPrompt,
    };

    const config: HttpConfig = {
      url: 'auth-service/feedback/decline/initial',
      method: 'post',
      data: payload,
      headers: {
        'Content-Type': 'application/json',
      },
    };

    request(
      config,
      onUpdateInitialFeedbackPromptSuccess,
      setLoading,
      onUpdateInitialFeedbackPromptError
    );
  };

  return { updateInitialFeedbackPrompt, loading };
};

export default useUpdateInitialFeedbackPrompt;
